import type { z } from 'zod';
import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createTransformer } from '../common/utils';
import { DBLessonTemplateSchema, LessonTemplateSchema } from './schemas';

type LessonTemplate = z.infer<typeof LessonTemplateSchema>;

export const LessonTemplateCodecConfig: TransformerConfig<
  typeof LessonTemplateSchema,
  typeof DBLessonTemplateSchema
> = {
  name: 'LessonTemplate',
  clientSchema: LessonTemplateSchema,
  dbSchema: DBLessonTemplateSchema,
  transformers: [
    // permissions: [permissionId] ↔ permissions: { permissionId: {} }
    createTransformer<typeof LessonTemplateSchema, typeof DBLessonTemplateSchema>({
      encoder: {
        sourceFields: ['permissions'] as const,
        encode: ({ permissions }) => ({
          permissions: Object.fromEntries(
            (permissions as LessonTemplate['permissions']).map(x => [x, {}])
          ),
        }),
      },
      decoder: {
        sourceFields: ['permissions'] as const,
        decode: ({ permissions = {} }) => ({
          permissions: Object.keys(permissions),
        }),
      },
    }),
  ],
};

export const encodeLessonTemplateToDb = createEncodeToDbFn(LessonTemplateCodecConfig);
export const decodeLessonTemplateFromDb = createDecodeFromDbFn(LessonTemplateCodecConfig);
